'use strict';

var _ = require('lodash');
var criteriaRuleDataService = function criteriaRuleDataService(configurationService, optWeekService, fieldNameTranslationService, systemStatusInterfaceStatusSearchService, SystemStatusFileEventTitles) {
  var conf = require('../config/operandsDataConf.json');
  function retrieveValue(current) {
    return current.value;
  }
  function transformAdjustment(item) {
    return {
      value: item.fieldName,
      dropdownVisibleValue: item.fieldLabel
    };
  }
  function transformFOgroups(groups, startKey, endKey) {
    return _.map(groups, function (group) {
      return group[startKey] + ' - ' + group[endKey];
    });
  }
  function getUniqueSortedConfiguredHostCarriers() {
    var configuredHostCarriers = configurationService.getConfiguredHostCarriers();
    var sConfiguredHostCarriers = _.chain(_.split(configuredHostCarriers, ',')).transform(function (result, current) {
      result.push({
        value: current
      });
    }).uniqBy('value').sortBy('value').value();
    return sConfiguredHostCarriers;
  }
  var operandTypesMapping = {
    significantMarket: function significantMarket() {
      var markets = configurationService.getNonCodeShareMarkets();
      var sMarket = _.chain(markets).transform(function (result, current) {
        result.push({
          value: current.origin + '-' + current.destination
        });
      }).uniqBy(retrieveValue).sortBy('value').value();
      return {
        multi: sMarket,
        '2multi': getUniqueSortedConfiguredHostCarriers()
      };
    },
    marketsOrigin: function marketsOrigin() {
      var markets = configurationService.getNonCodeShareMarkets();
      var mOrigin = _.chain(markets).transform(function (result, current) {
        result.push({
          value: current.origin
        });
      }).uniqBy(retrieveValue).sortBy('value').value();
      return {
        multi: mOrigin,
        '2multi': getUniqueSortedConfiguredHostCarriers()
      };
    },
    marketsDestination: function marketsDestination() {
      var markets = configurationService.getNonCodeShareMarkets();
      var mDest = _.chain(markets).transform(function (result, current) {
        result.push({
          value: current.destination
        });
      }).uniqBy(retrieveValue).sortBy('value').value();
      return {
        multi: mDest,
        '2multi': getUniqueSortedConfiguredHostCarriers()
      };
    },
    classGroups: function classGroups() {
      var classGroups = configurationService.getClassGroups();
      return {
        multi: _.transform(classGroups, function (result, current) {
          result.push({
            value: current
          });
        })
      };
    },
    marketEntity: function marketEntity() {
      var entities = configurationService.getEntities();
      return {
        multi: _.transform(_.filter(entities, {
          type: 'Market'
        }), function (result, current) {
          result.push({
            value: current.description,
            dropdownVisibleValue: current.description
          });
        })
      };
    },
    'legs.entity': function legsEntity() {
      var entities = configurationService.getEntities();
      return {
        multi: _.transform(_.filter(entities, {
          type: 'Flight'
        }), function (result, current) {
          result.push({
            value: current.description,
            dropdownVisibleValue: current.description
          });
        })
      };
    },
    workGroupEntity: function workGroupEntity() {
      var entities = configurationService.getEntities();
      return {
        multi: _.transform(_.filter(entities, {
          type: 'WorkGroup'
        }), function (result, current) {
          result.push({
            value: current.id,
            dropdownVisibleValue: current.description
          });
        })
      };
    },
    'custom:leg': function customLeg() {
      var legs = configurationService.getNonCodeShareLegs();
      return {
        multi: _.chain(legs).transform(function (result, current) {
          result.push({
            value: current.origin + '-' + current.destination
          });
        }).uniqBy(retrieveValue).sortBy('value').value()
      };
    },
    legsOrigin: function legsOrigin() {
      var legs = configurationService.getNonCodeShareLegs();
      return {
        multi: _.chain(legs).transform(function (result, current) {
          result.push({
            value: current.origin
          });
        }).uniqBy(retrieveValue).sortBy('value').value()
      };
    },
    legsDestination: function legsDestination() {
      var legs = configurationService.getNonCodeShareLegs();
      return {
        multi: _.chain(legs).transform(function (result, current) {
          result.push({
            value: current.destination
          });
        }).uniqBy(retrieveValue).sortBy('value').value()
      };
    },
    showupSeason: function showupSeason() {
      var seasons = configurationService.getSeasons();
      return {
        multi: _.uniqBy(_.transform(seasons, function (result, current) {
          result.push({
            value: current.name.toUpperCase(),
            dropdownVisibleValue: current.name
          });
        }), retrieveValue)
      };
    },
    classNames: function classNames() {
      var classes = configurationService.getClasses();
      return {
        multi: _.transform(classes, function (result, current) {
          result.push({
            value: current
          });
        })
      };
    },
    'legs.legCabins.cabinCode.displayable': function legsLegCabinsCabinCodeDisplayable() {
      var cabins = configurationService.getDisplayableCabins();
      return {
        multi: _.transform(cabins, function (result, current) {
          result.push({
            value: current
          });
        })
      };
    },
    'legs.legCabins.cabinCode': function legsLegCabinsCabinCode() {
      var cabins = configurationService.getCabins();
      return {
        multi: _.transform(cabins, function (result, current) {
          result.push({
            value: current
          });
        })
      };
    },
    cabinCode: function cabinCode() {
      var cabins = configurationService.getFoCabins();
      return {
        multi: _.transform(cabins, function (result, current) {
          result.push({
            value: current
          });
        })
      };
    },
    carrier: function carrier() {
      var benchmarkAirlines = _.uniq(_.flatten(_.map(configurationService.getFoBenchmarkCarriers(), 'benchmarkCarriers')));
      return {
        multi: _.uniqBy(_.transform(benchmarkAirlines, function (result, current) {
          result.push({
            value: current
          });
        }), retrieveValue)
      };
    },
    operatingCarrier: function operatingCarrier() {
      var airlines = configurationService.getHostAndSubsidiaryCarriers();
      return {
        multi: _.uniqBy(_.transform(airlines, function (result, current) {
          result.push({
            value: current
          });
        }), retrieveValue)
      };
    },
    number: function number() {
      var data = _.uniqBy(_.transform(configurationService.getFlightNumbers(), function (result, current) {
        var flightNumber = _.toString(current.flightNumber);
        result.push({
          value: flightNumber,
          dropdownVisibleValue: flightNumber,
          toString: _.constant(flightNumber)
        });
      }), retrieveValue);
      return {
        multi: data,
        '2combo': data
      };
    },
    pos: function pos() {
      var pos = configurationService.getPoses();
      var pPos = _.uniqBy(_.transform(pos, function (result, current) {
        result.push({
          value: current.spos
        });
      }), retrieveValue);
      return {
        multi: pPos,
        '2multi': getUniqueSortedConfiguredHostCarriers()
      };
    },
    daPos: function daPos() {
      var pos = configurationService.getDaPoses();
      return {
        multi: _.uniqBy(_.transform(pos, function (result, current) {
          result.push({
            value: current.spos
          });
        }), retrieveValue)
      };
    },
    serviceTypes: function serviceTypes() {
      var serviceTypes = configurationService.getServiceTypes();
      return {
        multi: _.transform(serviceTypes, function (result, current) {
          result.push({
            value: current
          });
        })
      };
    },
    yesno: function yesno() {
      return {
        combo: [{
          value: 'Y',
          dropdownVisibleValue: 'Yes'
        }, {
          value: 'N',
          dropdownVisibleValue: 'No'
        }]
      };
    },
    yesnoboolean: function yesnoboolean() {
      return {
        combo: [{
          value: true,
          dropdownVisibleValue: 'Yes'
        }, {
          value: false,
          dropdownVisibleValue: 'No'
        }]
      };
    },
    statuses: function statuses() {
      var data = ['FINISHED-PROCESSING', 'ERROR-PROCESSING', 'STARTED-PROCESSING', 'NEW-REQUEST'];
      return {
        multi: data
      };
    },
    ladderStatus: function ladderStatus() {
      return {
        multi: configurationService.getFoRecommendationLadderStatuses()
      };
    },
    optWeek: function optWeek() {
      var data = optWeekService.getOptWeekData();
      return {
        combo: data,
        multi: data,
        '2combo': data
      };
    },
    optimizationRules: function optimizationRules() {
      var result = _.map(configurationService.getOptimizationRules(), function (item) {
        return {
          value: item.ruleId,
          dropdownVisibleValue: item.ruleName
        };
      });
      return {
        multi: result
      };
    },
    allUsers: function allUsers() {
      var result = _.chain(configurationService.getAllUsers()).map(function (user) {
        return {
          value: user.getUserId(),
          dropdownVisibleValue: user.getDisplayName()
        };
      }).value();
      return {
        multi: result
      };
    },
    marketDemandAdjustments: function marketDemandAdjustments() {
      return {
        combo: _.map(fieldNameTranslationService.getAllFields('market'), transformAdjustment)
      };
    },
    flightAdjustments: function flightAdjustments() {
      return {
        combo: _.map(fieldNameTranslationService.getAllFields('flight'), transformAdjustment)
      };
    },
    serviceAdjustments: function serviceAdjustments() {
      return {
        combo: _.map(fieldNameTranslationService.getAllFields('service'), transformAdjustment)
      };
    },
    faresAdjustments: function faresAdjustments() {
      return {
        combo: _.map(fieldNameTranslationService.getAllFields('fares'), transformAdjustment)
      };
    },
    dowGroupsFlight: function dowGroupsFlight() {
      var data = configurationService.getFlightDowGroups();
      return {
        multi: _.transform(data, function (result, current) {
          result.push({
            value: current.name
          });
        })
      };
    },
    dowGroupsMarket: function dowGroupsMarket() {
      var data = configurationService.getMarketDowGroups();
      return {
        multi: _.transform(data, function (result, current) {
          result.push({
            value: current.name
          });
        })
      };
    },
    fileEvents: function fileEvents() {
      return {
        multi: _.map(configurationService.getInterfaceStatusFileEvents(), function (event) {
          return {
            value: event,
            dropdownVisibleValue: _.get(SystemStatusFileEventTitles, event, '')
          };
        })
      };
    },
    eventFrequencies: function eventFrequencies() {
      return {
        multi: systemStatusInterfaceStatusSearchService.getEventFrequencies()
      };
    },
    eventDirections: function eventDirections() {
      return {
        multi: systemStatusInterfaceStatusSearchService.getEventDirections()
      };
    },
    flightTags: function flightTags() {
      var flightTags = configurationService.getFlightTags();
      var flightTagNames = _.chain(flightTags).map(function (flightTag) {
        return flightTag.flightTagName;
      }).uniq().sort().value();
      return {
        multi: flightTagNames
      };
    },
    marketTier: function marketTier() {
      var data = configurationService.getMarketTiers();
      var marketTiers = _.chain(data).map('marketTier').uniq().filter().sort().value();
      marketTiers.unshift('Not assigned');
      return {
        multi: marketTiers
      };
    },
    tripType: function tripType() {
      return {
        multi: [{
          value: '1',
          dropdownVisibleValue: 'OW'
        }, {
          value: '2',
          dropdownVisibleValue: 'RT'
        }, {
          value: '3',
          dropdownVisibleValue: 'OWNC'
        }]
      };
    },
    minStayGroup: function minStayGroup() {
      var groups = configurationService.getFoMinStayGroups();
      var minGroups = transformFOgroups(groups, 'minStayStart', 'minStayEnd');
      var result = ['-', 'None'];
      result = _.concat(result, minGroups);
      result = _.uniq(result);
      return {
        multi: result
      };
    },
    maxStayGroup: function maxStayGroup() {
      var groups = configurationService.getFoMaxStayGroups();
      var maxGroups = transformFOgroups(groups, 'maxStayStart', 'maxStayEnd');
      var result = ['-', 'None'];
      result = _.concat(result, maxGroups);
      result = _.uniq(result);
      return {
        multi: result
      };
    },
    advancePurchaseGroup: function advancePurchaseGroup() {
      var groups = configurationService.getFoAdvPurchaseGroups();
      var advPurchaseGroups = transformFOgroups(groups, 'advancePurchaseStart', 'advancePurchaseEnd');
      var result = ['-', 'None'];
      result = _.concat(result, advPurchaseGroups);
      result = _.uniq(result);
      return {
        multi: result
      };
    },
    runNumber: function runNumber() {
      var recommendedFrequency = configurationService.getRecommendedFrequency();
      return {
        combo: Array.from({
          length: recommendedFrequency
        }, function (_, i) {
          return createRunNumberComboElement(i + 1);
        })
      };
    }
  };
  function createRunNumberComboElement(runNumber) {
    return {
      value: runNumber,
      dropdownVisibleValue: runNumber.toString()
    };
  }
  function getRulesData(dataName) {
    return operandTypesMapping[dataName]();
  }
  function mapConfiguration(config) {
    var mapped = {};
    config.forEach(function (criterion) {
      var mappedCriterion = {};
      criterion.operators.forEach(function (operator) {
        mappedCriterion[operator.operator] = operator.data;
      });
      mapped[criterion.criteriaName] = mappedCriterion;
    });
    return mapped;
  }
  var mappedConf = mapConfiguration(conf);
  function isEligibleCriterionFor2Multi(criterion) {
    var eligibleCriterion = ['Market', 'POS', 'Market Origin', 'Market Destination'];
    return _.includes(eligibleCriterion, criterion);
  }
  function getData(dataName, valueType, criterion) {
    var operandTypesData = getRulesData(dataName);
    if (!operandTypesData) {
      return;
    }
    return isEligibleCriterionFor2Multi(criterion) ? operandTypesData : operandTypesData[valueType];
  }

  /**
   *
   * @param {string} criterion - ex.  "Market Origin", "Market Entity"
   * @param {string} operator - ex. "=", "!=", "Contains"
   * @param {string} valueType - ex.  "text", "multi", "int"
   * @returns {*}
   */
  function getOperandData(criterion, operator, valueType) {
    var operators = mappedConf[criterion];
    if (!operators) {
      return;
    }
    var dataName = operators[operator];
    if (!dataName) {
      return;
    }
    return getData(dataName, valueType, criterion);
  }
  return {
    getOperandData: getOperandData,
    isEligibleCriterionFor2Multi: isEligibleCriterionFor2Multi
  };
};
criteriaRuleDataService.$inject = ['ConfigurationService', 'OptWeekService', 'FieldNameTranslationService', 'SystemStatusInterfaceStatusSearchService', 'SystemStatusFileEventTitles'];
module.exports = criteriaRuleDataService;